module.exports = __webpack_public_path__ + "img/case-logo-39.2faea0a9.png";